import * as $ from 'jquery';

window.$ = window.jquery = window.jQuery = $;

const $mainTemplate = $('main');

// get validation set
let checkDataIsAllowed = true;
let dataValidation = false; // set to "true" to enable data validation before sending to mixPanel

/**
 * Send the mix panel data
 * @param data
 */
let sendMixPanelData = function(data) {
    PMCMixpanel.track(PMCMixpanel.triggeredAction, data);
};

/**
 * Handle the mix panel triggered event
 */
let triggerMixPanelTracking = function($clickedEvent) {
    // if data validation is on and this attribute is not supported then do not make mix panel call
    if (dataValidation && !checkDataIsAllowed || hasMissingActionLocation()) {
        return false;
    }

    let mixPanelData = {};
    let $actionType = $clickedEvent.data('action_type');
    let $actionTarget = $clickedEvent.data('action_target');
    let $actionData = $clickedEvent.data('action_data');
    let $actionLocation = $clickedEvent.data('action_location');

    if ($clickedEvent.hasClass('withToggle')) {
        $actionType = getActionTypeFromToggleState($clickedEvent);
    }

    if ($actionType) {
        mixPanelData.action_type = $actionType;
    }

    if ($actionTarget) {
        mixPanelData.action_target = $actionTarget;
    }

    if ($actionData) {
        mixPanelData.action_data = $actionData;
    }

    if ($actionLocation) {
        mixPanelData.action_location = $actionLocation;
    }

    return mixPanelData;
};

/**
 * Given the click event on a toggle request, get the correct action type and return it
 * @param $clickedEvent
 */
let getActionTypeFromToggleState = function($clickedEvent) {
    let $currentState = $clickedEvent.data('current_state'); // the current state "on" or "off"
    let prefix = 'state_toggle_';

    // when user click favourite button, get the state based on "on" / "off"
    let $actionType = $clickedEvent.data(prefix + $currentState);

    // update the opposite state to become the new "current_state"
    if ($currentState === 'on') {
        $clickedEvent.data('current_state', 'off');
        $clickedEvent.attr('data-current_state', 'off');
    } else {
        $clickedEvent.data('current_state', 'on');
        $clickedEvent.attr('data-current_state', 'on');
    }

    return $actionType;
};

/**
 * Enforce template to have action location for mix panel tracking
 * @returns {boolean}
 */
function hasMissingActionLocation() {
    return $mainTemplate.data('action_location') === '' && $mainTemplate.data('action_errors') === 'on';
}

/**
 * Ensure template has location attribute or prompt error
 * @returns {boolean}
 */
let checkTemplateForDataLocationAttribute = function() {
    // enforcing mix panel attribute "actionLocation" in all templates
    if (hasMissingActionLocation()) {
        $('#mixPanelLogErrors').remove();
        $mainTemplate.prepend('<div id="mixPanelLogErrors" '
            + 'style="background: #fff;color:#f00;font-weight:bold;font-size: 15px; margin: 10px; padding: 8px;"'
            + '<p>Your template is missing the section "actionLocation". Fix this to correct mix panel tracking.</p>' +
            '</div>');
        return false;
    }
};

/**
 * Listen for changes to trackable input fields and update their parent listener
 */
let inputFieldListener = function() {
    let $inputDataListener = $('.mixPanelActionTrigger.inputDataListener');

    // on change of child input, update the parent data attributes
    $('input', $inputDataListener.parent()).on('keyup', function (e) {
        e.preventDefault();
        $inputDataListener.data('action_data', $(this).val());
    });
};

$(function() {
    // supporting multiple triggers (Basic Click, Menu Navigation, Forms)
    let selectableTriggers = '.mixPanelActionTrigger, ' +
        '.mixPanelActionTrigger.menuGroup > li > a,' +
        '.mixPanelActionTrigger.inputDataListener, .unsubscribe-track';

    $('body').on('click touchend', selectableTriggers, function(){
        let $clickedEvent = $(this);

        if ($clickedEvent.parent().parent().hasClass('unsubscribe-track')) {
            $clickedEvent.data('action_type', PMCMixpanel.triggeredActionEvents.UNSUBSCRIBED);
        } else if ($clickedEvent.parent().parent().hasClass('menuGroup')) {
            $clickedEvent.data('action_type', PMCMixpanel.triggeredActionEvents.CLICKED_MENU_ITEM);
        }

        if ($mainTemplate.data('action_location')) {
            $clickedEvent.data('action_location', $mainTemplate.data('action_location'));
        }

        sendMixPanelData(
            triggerMixPanelTracking($clickedEvent)
        );
    });

    $('#searchForm').on('submit', function () {
        const $this = $(this);

        $this.data('action_type', PMCMixpanel.triggeredActionEvents.SEARCHED);
        $this.data('action_data', $('#searchInput').val());

        sendMixPanelData(
            triggerMixPanelTracking($this)
        );
    });

    $(window).on('load', function(){
        checkTemplateForDataLocationAttribute();
        inputFieldListener();
    });
});
